export enum KycStepType {

    PersonalInfo = "PersonalInfo",
    Address = "Address",
    FinancialDetails = "FinancialDetails",
    TradingExperience = "TradingExperience",
    TopUp = "TopUp",
    TradingProfile = "TradingProfile",
    IdentityVerification = "IdentityVerification",
    StartTrading = "StartTrading",
}
